import React from "react";

import LoginForm from "./Form";


const LoginContainer = () => {
  return (
    <section className="grid__padding">
      <LoginForm />
    </section>
  );
};

export default LoginContainer;
